// List of common TLDs for URL validation
const validTLDs = [
  // Generic TLDs
  'com', 'org', 'net', 'edu', 'gov', 'mil', 'info', 'biz', 'name', 'pro',
  'io', 'ai', 'app', 'dev', 'co', 'me', 'tv', 'online', 'store', 'blog',
  'tech', 'site', 'xyz', 'club', 'shop', 'live', 'cloud', 'digital',

  // Country Code TLDs
  'us', 'uk', 'ca', 'au', 'de', 'fr', 'jp', 'cn', 'in', 'ru', 'br', 'it',
  'nl', 'es', 'eu', 'ch', 'se', 'no', 'dk', 'fi', 'pl', 'be', 'nz', 'at',
  'sg', 'hk', 'kr', 'tw', 'mx', 'za'
];

export const isValidUrl = (url: string): boolean => {
  // Remove leading/trailing whitespace
  url = url.trim();

  // Check if the URL starts with http://, https://, or www.
  if (!/^(https?:\/\/|www\.)/i.test(url)) {
    // If not, prepend 'http://'
    url = 'http://' + url;
  }

  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname;

    // Check if the hostname has at least one dot
    if (hostname.indexOf('.') === -1) {
      return false;
    }

    // Extract the TLD
    const parts = hostname.split('.');
    const tld = parts[parts.length - 1].toLowerCase();

    // Check if the TLD is in the list of valid TLDs
    return validTLDs.includes(tld);
  } catch (error) {
    return false;
  }
};

export const normalizeUrl = (url: string): string => {
  let normalizedUrl = url.trim().toLowerCase();
  if (!normalizedUrl.startsWith('http://') && !normalizedUrl.startsWith('https://')) {
    normalizedUrl = 'https://' + normalizedUrl;
  }
  return normalizedUrl;
};